<template lang="pug">

  .wrapper.wrapper-content.animated.fadeInRight
    .row
      .col-xs-12
        .tabs-container
          ul.nav.nav-tabs
            li(:class="tab == 'available' ? 'active' : ''" @click="changeTab('available')"): a Available
            li(:class="tab == 'notavailable' ? 'active' : ''" @click="changeTab('notavailable')")
              a
                span(v-show="pageType == 1") Rented
                span(v-show="pageType == 2") Sold
            li(:class="tab == 'notavailablebyagent' ? 'active' : ''" @click="changeTab('notavailablebyagent')"): a Not Available
            li(v-if="$ls.get('user').role_name == 'Super Admin' || $ls.get('user').role_name == 'Admin'" :class="tab == 'trash' ? 'active' : ''" @click="changeTab('trash')")
              a Trash

    .row.filter-project(:class="tab == 'trash' ? 'hide' : ''")
      .col-lg-12
        .ibox.float-e-margins
          .ibox-title(v-show="tab == 'available'" v-if="$ls.get('user').role_name == 'Super Admin' || $ls.get('user').role_name == 'Admin'")
            h4.pull-left Now {{ totalItems }} Projects
            .ibox-tools
              router-link(:to="`/${cat}/${$route.params.type}/create`").btn.btn-link <i class="fa fa-plus"></i> Add Project
          .ibox-content
            form(v-on:submit.prevent="onSubmitFilter")
              .row
                .col-sm-4
                  .form-group
                    label Search
                    input.form-control(type="text" placeholder="Search..." v-model="filterOptions.keywords")
                div(:class="assetType === 'Land' ? 'col-sm-4' : 'col-sm-2'")
                  .form-group
                    label Area
                    gmap-autocomplete.form-control#gmap-autocomplete(type="text" placeholder="Enter location" @place_changed="setFilterPlace" :select-first-on-enter="true")
                div(:class="assetType === 'Land' ? 'col-sm-4' : 'col-sm-4'")
                  .form-group
                    label Price Range
                    .row
                      .col-sm-6
                        input.form-control(type="text" placeholder="Min Price" v-model="filterOptions.min" @blur="filterOptions.min = formatNumber(filterOptions.min)")
                      .col-sm-6
                        input.form-control(type="text" placeholder="Max Price" v-model="filterOptions.max" @blur="filterOptions.max = formatNumber(filterOptions.max)")
                template(v-if="assetType != 'Land'")
                  .col-sm-2
                    .row
                      .col-xs-6
                        .form-group
                          label Bedroom
                          input.form-control(type="text" v-model="filterOptions.bedroom")
                      .col-xs-6
                        .form-group
                          label Bathroom
                          input.form-control(type="text" v-model="filterOptions.bathroom")

              .row
                .col-xs-12
                  button.btn.btn-sm.btn-primary(type="submit") Filter
                  | &nbsp;&nbsp;
                  button.btn.btn-sm.btn-white(type="button" @click="resetFilter") Reset

    .row(v-show="loading")
      .col-lg-12
        h1.text-center Loading...

    .row(v-show="condos.length == 0 && !loading")
      h1.text-center No content.

    .row(v-for="condo in condos")
      .col-lg-12
        .ibox.product-detail
          .ibox-content
            .row
              .col-lg-2.col-sm-4
                .project-image
                  // img(v-if="condo.pictures.length > 0" v-lazy="`${condo.pictures[0].path}`" @click="showLightbox(condo.pictures)").img-responsive
                  img(v-if="condo.pictures.length > 0" v-lazy="`${condo.pictures[0].path}`" @click="openLightboxGalleries(condo.pictures)").img-responsive
                  img(v-else src="~@/assets/noimage.png").img-responsive
                  i.pin.fa.fa-star(v-show="Number(condo.pintop)")
                  template(v-if="pageType === 2 && (tab === 'notavailable' || tab === 'notavailablebyagent')")
                    span.day-left SOLD
                  template(v-else)
                    span.day-left(v-show="condo.end_contact_days") {{ condo.end_contact_days }} days left.
                  //- span.multi-image(v-show="condo.pictures.length > 0"): i.fa.fa-th-large

              .col-lg-10.col-sm-8
                h3.font-bold.m-b-xs {{ condo.name }}
                .m-t-md: h2.product-main-price {{ formatNumber(condo.price) }} Baht <router-link v-if="condo.latitude && condo.longitude" :to="{ name: `Dashboard-House-Map`, query: { lat: condo.latitude, lng: condo.longitude } }" class="btn btn-sm btn-link"><i class="fa fa-map-o"></i></router-link>
                div ที่ดิน: {{ condo.land_size }} ตร.วา
                div(v-if="catID != 4") พื้นที่ใช้สอย: {{ condo.size }} ตร.เมตร, จำนวนชั้น: {{ condo.floor ? condo.floor : '-' }}
                div(v-if="catID != 4")
                  div(v-show="!Number(condo.studio)") <i class="fa fa-bed"></i> Bedroom: {{ condo.bedroom }} &nbsp;&nbsp;&nbsp; <i class="fa fa-bath"></i> Bathroom: {{ condo.bathroom }}
                  div(v-show="Number(condo.studio)") Studio room
                div(v-if="catID != 4") Furnishing: {{ condo.furnishing ? condo.furnishing : '-' }}, Electric: {{ condo.electric ? condo.electric : '-' }}
                .small.m-t-xs Remark: {{ condo.remark ? condo.remark : 'No remark.' }}
                .m-t.text-righ.product-btn-group
                  div(v-if="tab == 'trash'")
                    button.btn.btn-xs.btn-warning(v-if="$ls.get('user').role_name == 'Super Admin' || $ls.get('user').role_name == 'Admin'" @click="deleteCondo(condo.id)")
                      span(v-if="tab != 'trash'") Trash
                      span(v-else) Restore
                  div(v-else)
                    router-link.btn.btn-xs.btn-default(v-if="$ls.get('user').role_name == 'Super Admin' || $ls.get('user').role_name == 'Admin'" :to="`/${cat}/${$route.params.type}/${condo.id}/edit`"): i.fa.fa-edit
                    button.btn.btn-xs.btn-default(v-if="$ls.get('user').role_name == 'Super Admin' || $ls.get('user').role_name == 'Admin'" @click="showModal(condo.id)") OWNER
                    router-link.btn.btn-xs.btn-default(v-if="$ls.get('user').role_name == 'Super Admin' || $ls.get('user').role_name == 'Sale'" :to="`/${cat}/${$route.params.type}/${condo.id}/contract`")
                      span(v-show="pageType == 1") Rented
                      span(v-show="pageType == 2") Sold
                    router-link.btn.btn-xs.btn-default(v-if="$ls.get('user').role_name == 'Super Admin' || $ls.get('user').role_name == 'Admin'" :to="`/${cat}/${$route.params.type}/${condo.id}/contract?byAdmin=true`") Not Available
                    button.btn.btn-xs.btn-warning(v-if="$ls.get('user').role_name == 'Super Admin' || $ls.get('user').role_name == 'Admin'" @click="deleteCondo(condo.id)")
                      span(v-if="tab != 'trash'") Trash
                      span(v-else) Restore
          .ibox-footer
            span.product-id No. {{ condo.id_show }}
            span.pull-right.created-meta
              span(v-show="condo.update_date") Updated: {{ condo.update_by }} {{ formatDate2(condo.update_date) }}
            //- span.pull-right.created-meta(v-if="$ls.get('user').role_name == 'Super Admin' || $ls.get('user').role_name == 'Admin' || $ls.get('user').role_name == 'Operator'")
              span(v-if="condo.seller_name") Sale: {{ condo.seller_name }}
              span Admin: {{ condo.create_by ? condo.create_by : '-' }}

    .row(v-if="pageCount")
      .col-xs-12
        .ibox.float-e-margins
          .ibox-content
            paginate(:page-count="pageCount" :click-handler="changePage" :prev-text="'Prev'" :next-text="'Next'" :force-page="pageNo-1" :initial-page="pageNo-1").pagination

    modal(name="owner" height="auto" :adaptive="true")
      .widget.white-bg.p-xl
        h1.text-center(v-show="ownerLoading") Loading...
        div(v-show="!ownerLoading")
          h2 {{ owner.owner ? owner.owner : '-' }}
          ul.list-unstyled.m-t-md
            li
              span.fa.fa-phone.m-r-xs
              label Phone No :
              | &nbsp;&nbsp;<a :href='`tel:${owner.phone}`'>{{ owner.phone ? `${owner.phone}` : '-' }}</a>
            li
              label Line ID :
              | &nbsp;&nbsp;{{ owner.line ? owner.line : '-' }}
            li
              span.fa.fa-sticky-note-o.m-r-xs
              label Note :
              | &nbsp;&nbsp;{{ owner.note ? owner.note : '-' }}

    lightbox(ref="lightbox" :images="lightboxImages" :show-caption="false" :show-light-box="false")

    lightbox-galleries(
      v-if="lightGalleries.isShow"
      :items="lightboxImages"
      @onClose="lightGalleries.isShow = false")

</template>

<script>
  // import $ from 'jquery'
  import axios from 'axios'
  import moment from 'moment'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import toastr from 'toastr'
  import 'toastr/build/toastr.min.css'
  import numeral from 'numeral'
  import Slick from 'vue-slick'
  import 'slick-carousel/slick/slick.css'
  import 'slick-carousel/slick/slick-theme.css'
  import Paginate from 'vuejs-paginate'
  import Lightbox from 'vue-image-lightbox'
  import 'vue-image-lightbox/dist/vue-image-lightbox.min.css'
  import _ from 'lodash'
  import LightboxGalleries from '@/components/LightboxGalleries'
  import ModalSharedLink from '@/components/modal/sharedLink'

  export default {
    components: {
      Slick,
      Paginate,
      Lightbox,
      LightboxGalleries,
      ModalSharedLink
    },
    data () {
      return {
        isFirst: true,
        baseUrl: global.baseUrl,
        catID: 2,
        cat: this.$route.fullPath.split('/')[1],
        loading: false,
        ownerLoading: false,
        tab: this.$route.query.tab ? this.$route.query.tab : 'available',
        condos: [],
        owner: {},
        filterOptions: {
          keywords: this.$route.query.keywords ? this.$route.query.keywords : '',
          lat: this.$route.query.latitude ? this.$route.query.latitude : '',
          lng: this.$route.query.longitude ? this.$route.query.longitude : '',
          min: this.$route.query.min_price ? this.$route.query.min_price : '',
          max: this.$route.query.max_price ? this.$route.query.max_price : '',
          bedroom: this.$route.query.bedroom ? this.$route.query.bedroom : '',
          bathroom: this.$route.query.bathroom ? this.$route.query.bathroom : ''
        },
        filterUrl: '',
        pageType: this.$route.params.type === 'rent' ? 1 : 2,
        pageNo: this.$route.query.page ? this.$route.query.page : 1,
        assetType: this.$route.name.split('-')[1],
        pageSize: 10,
        pageCount: 0,
        totalItems: 0,
        slickOptions: { dots: true, infinite: true },
        lightboxImages: [],
        lightGalleries: {
          isShow: false
        }
      }
    },
    beforeCreate () {
      if (this.$route.params.type === undefined) this.$router.push('/house/sale')
    },
    created () {
      switch (this.$route.fullPath.split('/')[1]) {
        case 'house':
          this.catID = 2
          break
        case 'townhouse':
          this.catID = 3
          break
        case 'land':
          this.catID = 4
          break
        case 'building':
          this.catID = 5
          break
        default:
          this.catID = 2
      }
    },
    mounted () {
      // this.fetchCondo()
      this.onSubmitFilter()
    },
    watch: {
      '$route.params.type' (to, from) {
        this.pageType = to === 'rent' ? 1 : 2
        this.tab = 'available'
        this.resetFilter()
      }
    },
    methods: {
      formatNumber (number) {
        return numeral(number).format('0,0')
      },
      deformatNumber (number) {
        return numeral(number).value()
      },
      formatDate (datetime) {
        return moment(datetime).format('D MMM YYYY')
      },

      formatDate2 (datetime) {
        return moment(datetime).format('D/M/YYYY hh:mm')
      },

      fetchCondo () {
        this.loading = true
        this.condos = []
        axios.get(`project/${this.tab}/?cat_id=${this.catID}&type_id=${this.pageType}&page_no=${this.pageNo}&page_size=${this.pageSize}${this.filterUrl}`).then((res) => {
          switch (res.data.responseCode) {
            case 200:
              this.condos = res.data.data
              this.pageCount = Math.ceil(res.data.totalRecord > this.pageSize ? res.data.totalRecord / this.pageSize : 0)
              this.totalItems = res.data.totalRecord
              break
            case 405:
              toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            case 406:
              toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            default:
              console.log(res.data.message)
          }
          this.loading = false
        })
      },
      changeTab (to) {
        this.tab = to
        // this.fetchCondo()
        this.$router.push({query: {tab: to}})
        this.resetFilter()
      },
      changePage (to) {
        let temp = _.clone(this.$route.query)
        temp.page = to
        this.pageNo = to
        this.$router.push({query: temp})
        this.fetchCondo()
      },
      fetchOwner (id) {
        this.ownerLoading = true
        axios.get(`project/owner/${id}`).then((res) => {
          switch (res.data.responseCode) {
            case 200:
              this.owner = res.data.data
              break
            case 405:
              toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            case 406:
              toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
              this.$router.push('/login')
              break
            default:
              console.log(res.data.message)
          }
          this.ownerLoading = false
        })
      },
      deleteCondo (id) {
        var _this = this
        swal({
          title: 'Are you sure?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.tab === 'trash' ? 'Restore' : 'Delete!',
          cancelButtonText: 'No'
        }).then(function () {
          if (_this.tab === 'trash') {
            axios.put(`project/restore/id/${id}`).then((res) => {
              switch (res.data.responseCode) {
                case 200:
                  swal(
                    'Restored!',
                    'Project has been restored.',
                    'success'
                  )
                  break
                case 405:
                  toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
                  this.$router.push('/login')
                  break
                case 406:
                  toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
                  this.$router.push('/login')
                  break
                default:
                  console.log(res.data.message)
              }
              _this.fetchCondo()
            })
          } else {
            axios.delete(`project/id/${id}`).then((res) => {
              switch (res.data.responseCode) {
                case 200:
                  swal(
                    'Deleted!',
                    'Project has been deleted.',
                    'success'
                  )
                  break
                case 405:
                  toastr.error('This account has login by other.', res.data.message, { timeOut: 4000 })
                  this.$router.push('/login')
                  break
                case 406:
                  toastr.error('This account has been deleted please contact admin.', res.data.message, { timeOut: 4000 })
                  this.$router.push('/login')
                  break
                default:
                  console.log(res.data.message)
              }
              _this.fetchCondo()
            })
          }
        }, function (dismiss) {
          if (dismiss === 'cancel') {
            swal(
              'Cancelled',
              _this.tab === 'trash' ? 'Project still gone :(' : 'Project is safe :)',
              'error'
            )
          }
        })
      },
      resetFilter () {
        this.filterUrl = ''
        this.filterOptions = {
          keywords: '',
          lat: '',
          lng: '',
          min: '',
          max: '',
          bedroom: '',
          bathroom: ''
        }
        this.pageNo = 1
        document.getElementById('gmap-autocomplete').value = ''
        if (!_.isEmpty(this.$route.query.tab)) this.$router.push({query: {tab: this.$route.query.tab}})
        else this.$router.push({query: {}})
        this.fetchCondo()
      },
      setFilterPlace (place) {
        this.filterOptions.lat = place.geometry.location.lat()
        this.filterOptions.lng = place.geometry.location.lng()
      },
      onSubmitFilter () {
        this.filterUrl = ''
        if (this.filterOptions.keywords) this.filterUrl += `&keywords=${this.filterOptions.keywords}`
        if (this.filterOptions.lat) this.filterUrl += `&latitude=${this.filterOptions.lat}`
        if (this.filterOptions.lng) this.filterUrl += `&longitude=${this.filterOptions.lng}`
        if (this.filterOptions.min) this.filterUrl += `&min_price=${this.deformatNumber(this.filterOptions.min)}`
        if (this.filterOptions.max) this.filterUrl += `&max_price=${this.deformatNumber(this.filterOptions.max)}`
        if (this.filterOptions.bedroom) this.filterUrl += `&bedroom=${this.filterOptions.bedroom}`
        if (this.filterOptions.bathroom) this.filterUrl += `&bathroom=${this.filterOptions.bathroom}`

        if (!_.isEmpty(this.$route.query.tab)) this.filterUrl += `&tab=${this.$route.query.tab}`

        if (this.isFirst) {
          this.isFirst = false
          if (!_.isEmpty(this.$route.query.page)) {
            this.filterUrl += `&page=${this.$route.query.page}`
          }
        } else {
          this.pageNo = 1
        }
        if (!_.isEmpty(this.filterUrl)) {
          this.$router.push(`${this.$route.path}?${this.filterUrl}`)
        } else {
          this.$router.push(`${this.$route.path}`)
        }
        this.fetchCondo()
      },
      showModal (id) {
        this.fetchOwner(id)
        this.$modal.show('owner')
      },
      hideModal () {
        this.$modal.hide('owner')
      },
      showLightbox (images) {
        this.lightboxImages = []
        for (var image of images) {
          image.src = `${image.path}`
          image.thumb = `${image.path}`
          this.lightboxImages.push(image)
        }
        this.$refs.lightbox.showImage(0)
      },
      openLightboxGalleries (images) {
        this.lightboxImages = []
        for (var image of images) {
          image.src = `${image.path}`
          image.thumb = `${image.path}`
          this.lightboxImages.push(image)
        }
        this.lightGalleries.isShow = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?74fb7213